import { useEffect } from 'react'

const guards = new Set<() => boolean>()

/** True when any registered editor/session has unsaved changes. */
export function hasUnsavedEdits(): boolean {
  for (const guard of guards) {
    if (guard()) return true
  }
  return false
}

/** Register a screen that blocks PWA reload while dirty. */
export function useUnsavedGuard(isDirty: boolean): void {
  useEffect(() => {
    const guard = () => isDirty
    guards.add(guard)
    return () => {
      guards.delete(guard)
    }
  }, [isDirty])
}
